import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { AmplifyApiService } from 'src/app/core/services/amplify-api.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import {
  LoadSurveysSuccess,
  SaveSurveysComplete,
  SaveSurveysFail
} from 'src/app/features/surveys/redux/surveys.actions';
import { Survey } from 'src/app/models/survey';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({
  providedIn: 'any'
})
export class SurveyService {
  public signedRequests: any;
  public owner = '';
  public selectedKeys: string[] = [];
  public allKeys: string[] = [];
  public surveys_api = APIS.SURVEYS;
  public responses_api = APIS.RESPONSES;
  public type = 'surveys';
  public util = new UtilityService();

  constructor(
    private store: Store,
    private toastrService: NbToastrService,
    private apiService: AmplifyApiService
  ) {}

  public loadSurveysAmplify(reload?: boolean | undefined) {
    this.apiService
      .get(this.surveys_api, `/${ENVIRONMENT.name}/surveys`, {})
      .then((response) => {
        if (reload) {
          this.toastrService.show(status, 'Fetching Surveys Complete', {
            status: 'success'
          });
        }
        this.store.dispatch(new LoadSurveysSuccess(response));
      })
      .catch((error) => {
        console.error(error);
        const message = this.util.convertErrorToMessage(error);
        this.toastrService.show(status, 'Fetch Failed: ' + message, { status: 'danger' });
      });
  }

  public postSurveysAmplify(survey: Survey, edit = false) {
    this.apiService
      .post(this.surveys_api, `/${ENVIRONMENT.name}/surveys`, { body: survey })
      .then((response) => {
        this.store.dispatch(new SaveSurveysComplete(response, survey, edit));
      })
      .catch((error) => {
        this.store.dispatch(new SaveSurveysFail(error));
      });
  }
}
